import {AspectRatio} from '@contentlab/types/aspectRatio';
import contentStudioInstance from '@/utils/axiosContentStudio';

export type AssetSorting = {
  field: string;
  order: 'asc' | 'desc';
};

type AssetParams = {
  sorting: AssetSorting;
  filters: AssetFilters;
};

export type AssetFilters = {
  folder?: string[];
  source?: string[];
  language?: string[];
  aspect_ratio?: AspectRatio[];
  name?: string;
  ids?: string[];
  start_date?: Date;
  end_date?: Date;
  type?: 'upload' | 'result';
};

type AssetDTO = {
  id: string;
  name: string;
  metadata: {
    durationMillis: number;
    fileSizeBytes: number;
    height: number;
    width: number;
    language?: string | null;
    aspectRatio?: AspectRatio | null;
  };
  project?: {
    name: string;
    id: string;
  };
  createdAt?: number;
  originalAsset?: {
    name: string;
    id: string;
  };
  thumbnailUrl?: string;
  type: 'upload' | 'result';
  url?: string;
  status: string;
};

type FiltersDTO = {
  projects: {id: string; name: string}[];
  sources: {id: string; name: string}[];
  languages: string[];
  formats: string[];
};

const assetFetchers = {
  getAssets: async (params: AssetParams) => {
    const {filters, sorting} = params;
    const query = new URLSearchParams();
    Object.entries(filters)
      .filter(([_, value]) => value)
      .forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => {
            query.append(key, v);
          });
        } else {
          query.append(
            key,
            value instanceof Date ? value.toISOString() : value
          );
        }
      });
    if (sorting.field !== '') {
      query.append('sort_by', sorting.field);
    }
    if (sorting.order) {
      query.append('sort_order', sorting.order);
    }
    const response = await contentStudioInstance.get<{assets: AssetDTO[]}>(
      '/api/v1/assets',
      {
        params: query,
      }
    );
    return response.data;
  },
  getFilters: async () => {
    const response = await contentStudioInstance.get<FiltersDTO>(
      '/api/v1/assets/filters'
    );
    return response.data;
  },
  getAssetById: async (id: string) => {
    const response = await contentStudioInstance.get<AssetDTO>(
      `/api/v1/assets/${id}`
    );
    return response.data;
  },
};

export default assetFetchers;
